function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5024 5.21741H0.497594C0.176 6.08406 0 7.02144 0 8C0 8.97856 0.176 9.91594 0.497594 10.7826H15.5024C15.824 9.91594 16 8.97856 16 8C16 7.02144 15.824 6.08406 15.5024 5.21741Z",
  fill: "#0052B4"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99995 0C5.57523 0 3.40264 1.07887 1.93555 2.78259H14.0643C12.5973 1.07887 10.4247 0 7.99995 0Z",
  fill: "#D80027"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0644 13.2174H1.93555C3.40264 14.9211 5.57523 16 7.99995 16C10.4247 16 12.5973 14.9211 14.0644 13.2174Z",
  fill: "#D80027"
});
const SvgThailand = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgThailand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thailand.2aa35d16.svg";
export { ForwardRef as ReactComponent };